import { motion } from "framer-motion";

import { IMAGES } from "@/data/content";

const CEREMONY_IMG = IMAGES.mural;

const chapters = [
  {
    no: "01",
    title: "The Corner",
    body: "On Barkly Street in the heart of Footscray, our little corner brings a taste of home to the neighbourhood — coffee, warm bread and a friendly welcome.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: [0.19, 1, 0.22, 1], delay: i * 0.12 },
  }),
};

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative bg-cafe py-28 md:py-40">
      <div className="mx-auto max-w-[1500px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1 }}
          className="mb-20 max-w-3xl"
        >
          <p className="mb-6 font-body text-xs uppercase tracking-[0.35em] text-accent">Our Story</p>
          <h2 className="font-display text-4xl leading-tight tracking-tight text-[var(--text)] sm:text-5xl lg:text-6xl">
            More local than landmark.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* Mural image on the left */}
          <motion.div
            variants={reveal}
            custom={0}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            className="flex flex-col gap-4 lg:col-span-6"
          >
            <div className="relative overflow-hidden clip-frame min-h-[400px]">
              <img src={CEREMONY_IMG} alt="For the love of Footscray mural" className="h-full w-full object-cover" />
            </div>
            <p className="font-serif-c text-xl italic text-[var(--text)]/70">Made by family, for the neighbourhood</p>
          </motion.div>

          {chapters.map((c, i) => (
            <motion.article
              key={c.no}
              data-testid={`manifesto-chapter-${c.no}`}
              variants={reveal}
              custom={i + 1}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="group flex flex-col justify-center border border-[var(--line)] bg-surface p-10 md:p-12 transition-colors duration-500 hover:border-accent/60 lg:col-span-6 min-h-[440px]"
            >
              <span className="font-display text-6xl text-accent/70 transition-colors duration-500 group-hover:text-accent">
                {c.no}
              </span>
              <div className="mt-8">
                <h3 className="font-serif-c text-4xl text-[var(--text)]">{c.title}</h3>
                <p className="mt-4 max-w-md font-body text-lg leading-relaxed text-[var(--text)]/65">{c.body}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
